export const STATE_SEARCH_PARAM = 'state';
